import { useTranslation } from 'react-i18next';
import tellUsMoreBg from '@assets/images/tell-us-more.webp';
import { Flex, Text } from '@radix-ui/themes';
import { HeaderItalic } from '@/components/common';
import { WizardHeader, WizardScreen } from '@/components/layout';
import { ContinueButton } from '@/components/onboarding';
import type { OnboardingStepProps } from './types';

export function PersonalityIntroStep({ flow }: OnboardingStepProps) {
  const { t } = useTranslation('onboarding');
  // Navigation only — no form fields; flow.next is temporary wizard routing until full store migration.

  return (
    <WizardScreen bgPicture={tellUsMoreBg} header={<WizardHeader withLogoutButton hasMedia />}>
      <Flex direction="column" minHeight="0" height="100%" pb="5" position="relative">
        <Flex direction="column" justify="center" flexGrow="1" minHeight="0">
          <HeaderItalic>{t('steps.personalityIntro.title')}</HeaderItalic>
          <Text as="p" size="2" color="gray" mt="3">
            {t('steps.personalityIntro.description')}
          </Text>
        </Flex>
        <ContinueButton onClick={flow.next}>{t('actions.letsGo')}</ContinueButton>
      </Flex>
    </WizardScreen>
  );
}
